import { CustomizeWelcomeActionType } from './customizeWelcomeTypes';

export const setWelcomeLocale: (str) => any = (str) => async (dispatch) => {
  dispatch({
    type: CustomizeWelcomeActionType.SET_WELCOME_LOCALE,
    payload: str,
  });
};

export const setWelcomeCustomerName: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_WELCOME_NAME,
      payload: str,
    });
  };

export const setWelcomeAreaCode: (str) => any = (str) => async (dispatch) => {
  dispatch({
    type: CustomizeWelcomeActionType.SET_WELCOME_AREA_CODE,
    payload: str,
  });
};

export const setWelcomeCustomerPhone: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_WELCOME_PHONE,
      payload: str,
    });
  };

export const setWelcomeSelectedDatePreorderTime: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_WELCOME_DATE_PREORDER_TIME,
      payload: str,
    });
  };

export const setWelcomeSelectedTimePreorderTime: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_WELCOME_TIME_PREORDER_TIME,
      payload: str,
    });
  };

export const setWelcomeCustomerAddress: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_WELCOME_ADDRESS,
      payload: str,
    });
  };

export const setWelcomeCustomerComment: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_WELCOME_COMMENT,
      payload: str,
    });
  };

export const setWelcomeShareMealCondictions: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_WELCOME_SHARE_MEAL_CONDICTIONS,
      payload: str,
    });
  };

export const setWelcomeSelectedServeType: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_SELECTED_SERVETYPE,
      payload: str,
    });
  };

export const setWelcomeSelectedTakeoutServeType: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_SELECTED_TAKEOUT_SERVETYPE,
      payload: str,
    });
  };

export const setWelcomeSelectedServeTypeValid: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_IS_SELECTED_SERVETYPE_VALID,
      payload: str,
    });
  };

export const setWelcomeIsCustomerPhoneValid: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_IS_CUSTOMER_PHONE_VALID,
      payload: str,
    });
  };

export const setWelcomeIsCustomerNameValid: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_IS_CUSTOMER_NAME_VALID,
      payload: str,
    });
  };

export const setWelcomeIsCustomerAddressValid: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_IS_CUSTOMER_ADDRESS_VALID,
      payload: str,
    });
  };

export const setWelcomeIsShareMealValid: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_IS_SELECTED_SHAREMEAL_VALID,
      payload: str,
    });
  };

export const setWelcomePreorderTimeValid: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CustomizeWelcomeActionType.SET_IS_SELECTED_PREORDER_TIME_VALID,
      payload: str,
    });
  };
